//#region [IMPORT]

// === THIRD-PARTY ===
import React from 'react';

// *** MUI / STYLE ***
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

//#endregion

//-----------------------------------------------------------------
export function ThumbnailPlaceholder({ id, index, is_drag }) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme = useTheme();

  //#endregion

  //#region [STYLES]
 
  const _styles = {
    container: {
      'white-space' : 'nowrap'     ,
      overflow      : 'visible'    ,
      width         : '100px'      ,
      height        : '125px'      ,
      border        : '5px dotted' ,
      borderColor   : theme.palette.primary.alt[theme.palette.mode],
      margin         : '1rem'         ,
      justifyContent : 'center'       ,
    },
    container_drag: {
      'white-space' : 'nowrap'  ,
      overflow      : 'visible' ,
      width         : '100px'   ,
      height        : '125px'   ,
      margin         : '1rem'         ,
      justifyContent : 'center'       ,
    },
  }

  const CONTAINER = {
    style: _styles.container,
  }

  const CONTAINER_DRAG = {
    style: _styles.container_drag,
  }

  //#endregion
  
  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    const props = is_drag ? CONTAINER_DRAG : CONTAINER;
    return (
      <Box { ...props } />
    )
  } 

  //#endregion

  return display();
};
